import { CONSTANTS } from '../constants/constants';
import { BaseService } from './base';
import { HeaderBuilder } from '@tme/toyota-common';

const {
	API: { SERVICE, ENDPOINTS }
} = CONSTANTS;

const _headers = new HeaderBuilder().addBrand().addLocale().build();

export class AggregatorService extends BaseService {
	host: string;
	headers: Headers;

	constructor() {
		super();
		this.host = SERVICE.AGGREGATOR;
		//@ts-expect-error
		this.headers = new Headers(_headers);
	}

	async getLabels<T>(path: string): Promise<T> {
		return await this.fetch<T>({
			url: `${this.host}${path}`,
			headers: this.headers
		});
	}

	async fetchLabels(): Promise<any> {
		return await this.getLabels<any>(
			ENDPOINTS.AGGREGATOR.VINCHECKER_LABELS
		);
	}

	async getVehicleData<T>(vin: string): Promise<T> {
		return await this.fetch<T>({
			url: `${this.host}/vehicle/vin/${vin}/vinChecker`,
			headers: this.headers
		});
	}
}

export const aggregatorService = new AggregatorService();
